module.exports = __webpack_public_path__ + "static/open-sans-bold-e5111caba5b811a73d995786db3c61ea.ttf";